var collapsible_list_pair_default = {
  "container": "h94o9",
  "title": "Oc6cy",
  "viewerContainer": "DOAyT",
  "titleContainer": "Q4Eoh",
  "expandIcon": "cOA6m",
  "dndIcon": "Rg-c8",
  "RTL": "n4f0-",
  "LTR": "dOHb5",
  "itemContainer": "PxuQr",
  "itemContainerViewer": "RWGn5",
  "mouseDown": "WsFGm",
  "innerEditor": "FUsj6",
  "item": "x-GJ5",
  "floatingAddPluginMenuWrapper": "ek0WQ",
  "childrenHidden": "v3EcM"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
